var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgExperimentsNav = function SvgExperimentsNav(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.942 16.57 14 8.335V5h.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-5c-.275 0-.5.225-.5.5s.225.5.5.5h.5v3.335L5.058 16.57C3.926 18.456 4.8 20 7 20h10c2.2 0 3.074-1.543 1.942-3.43M7.766 14 11 8.61V5h2v3.61L16.234 14z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExperimentsNav);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;